export default __webpack_public_path__ + "static/media/featured-banner.3b011c6f.jpg";